import { useEffect } from 'react';

/** Pone un nombre más preciso en la pestaña cuando la pantalla ya sabe de quién se trata. */
export function useTitulo(titulo: string | null | undefined): void {
  useEffect(() => {
    if (titulo) document.title = `${titulo} · MedChoice`;
  }, [titulo]);
}
